import React, { useState, useEffect } from 'react';
import { fetchSpecializations, exportSpecializationsExcel } from '../services/academicFinanceApi';
import { FinanceTable } from './FinanceTable';
import Notifier from '../../../Utils/notify';
import exporticon from '../../../assets/icons/export-data.svg';

export const SpecializationsList = ({ courseId, onSpecializationClick, onUpdateGrandTotals }) => {
  const [specializations, setSpecializations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [exporting, setExporting] = useState(false);
  const pageSize = 10;

  useEffect(() => {
    loadSpecializations(currentPage);
  }, [currentPage, courseId]);

  const loadSpecializations = async (page) => {
    try {
      setLoading(true);
      const data = await fetchSpecializations(courseId, page, pageSize);
      setSpecializations(data.results || []);
      
      if (data.grand_totals) {
        onUpdateGrandTotals(data.grand_totals);
      }
      
      if (data.count) {
        setTotalPages(Math.ceil(data.count / pageSize));
      }
    } catch (error) {
      console.error('Error loading specializations:', error);
      Notifier.error('Failed to load specializations');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      setExporting(true);
      await exportSpecializationsExcel(courseId);
      Notifier.success('Specializations data exported successfully');
    } catch (error) {
      console.error('Error exporting specializations:', error);
      Notifier.error('Failed to export specializations data');
    } finally {
      setExporting(false);
    }
  };

  const handleRowClick = (specialization) => {
    onSpecializationClick('academic-groups', specialization.id, specialization.name);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    { header: 'ID', accessor: 'id', width: '80px' },
    { header: 'Specialization Name', accessor: 'name', width: '200px' },
    { header: 'Course Name', accessor: 'course_name', width: '180px' },
    { header: 'Course Alias', accessor: 'course_alias', width: '120px' },
    { 
      header: 'Total Students', 
      accessor: 'total_students', 
      width: '120px',
      align: 'center'
    },
    { 
      header: 'Imposed Fees', 
      accessor: 'total_imposed_fees', 
      width: '150px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Scheduled Fees', 
      accessor: 'total_scheduled_fee', 
      width: '150px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Paid Fees', 
      accessor: 'total_paid_fees', 
      width: '150px',
      align: 'right',
      format: 'currency'
    },
  ];

  return (
    <div className="specializations-list">
      <div className="list-header">
        <h2>Specializations</h2>
        <button 
          className="export-btn" 
          onClick={handleExport}
          disabled={exporting}
        >
          <img src={exporticon} alt="Export" />
          {exporting ? 'Exporting...' : 'Export'}
        </button>
      </div>

      <FinanceTable
        data={specializations}
        columns={columns}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
      />
    </div>
  );
};
